// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQVoxel_graphic_eKfwn"};